import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../components/Loader';
import { useSettings } from '../context/SettingsContext';

const ServiceDetail = () => {

    const { id } = useParams();
    const [srvDetail, setSrvDetail] = useState(null);
    const { renderHTML } = useSettings();

    const getSrvDetail = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-services-detail/${id}`);
            setSrvDetail(res.data.data)
        } catch (err) {
            console.log('Error Service Detail content', err)
        }
    }

    useEffect(() => {
        getSrvDetail();
    }, [id])


    if (srvDetail === null) {
        <Loader />
    }

    console.log(srvDetail)

    return (
        <>
            <section className="inner-banner">
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6" data-aos="flip-left" data-aos-duration={1000}>
                            <div className="inner-banner-left">
                                <h1>services detail</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src="/images/hero-tires.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <section className="services-dt-imgWrapper">
                <div className="container-fluid web-padding">
                    <div className="row" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="col-md-12">
                            <div className="services-dt-img">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${srvDetail?.photo}`} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mobile-tyre-service">
                <div className="container-fluid web-padding">
                    <div className="row" data-aos="fade-right" data-aos-duration={1000}>
                        <div className="col-md-12">
                            <div className="mobile-tyre-servicedt">
                                <h2>{srvDetail?.title}</h2>
                                {renderHTML(srvDetail?.details)}
                                {/* <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Error quisquam provident porro
                                    ullam sunt saepe dolorum suscipit nesciunt esse tempore fugiat soluta quam quod possimus
                                    repellendus, recusandae inventore consequatur libero quibusdam quis dolor in praesentium
                                    rerum voluptatibus? Ratione, exercitationem voluptate nisi ducimus placeat, quasi similique
                                    porro expedita nihil labore veniam?</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, quaerat reprehenderit hic
                                    cum exercitationem, assumenda nostrum nobis veritatis perspiciatis dicta vitae quibusdam.
                                    Quam, quia. Veritatis eligendi illo nobis quo temporibus eius officiis nostrum a ex
                                    recusandae omnis illum obcaecati, voluptatum sunt aliquam ipsum animi rerum repudiandae
                                    ipsa? Nulla sed, iure fugit nam, rerum nobis autem itaque aperiam voluptate similique
                                    corrupti ex numquam. Saepe vel harum fugit esse accusamus. Repudiandae, illum dolorum earum
                                    neque, quasi fuga enim aliquam blanditiis tempore, id amet natus vero voluptates a excepturi
                                    magni eligendi delectus aliquid consectetur debitis repellendus dignissimos. Deleniti labore
                                    ducimus dolores eius mollitia facilis consequatur exercitationem cumque quod, vero quibusdam
                                    saepe earum. Eum repellendus optio laboriosam, officia laborum veritatis animi enim autem
                                    tempora odio sed corrupti error repellat, possimus quos quod vitae consequuntur explicabo
                                    recusandae sint, quisquam asperiores distinctio? Consequuntur dolore fuga itaque fugit
                                    necessitatibus obcaecati voluptatibus porro ipsum officia maxime earum quis, aut facilis
                                    rerum dicta quas sit dolor minima blanditiis eos nihil. Ut sapiente quasi iusto doloremque
                                    alias ratione earum quos atque, reiciendis facere reprehenderit! Similique dolore, inventore
                                    quas a voluptates magni. Eaque optio libero animi suscipit. Officia, voluptatibus nulla ut
                                    voluptates error necessitatibus ratione harum autem eligendi sequi, tempora eos!</p> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="row service-certificate-row">
                        <div className="col-md-4" data-aos="fade-left" data-aos-duration={1000}>
                            <div className="service-certificate">
                                <h3> CAPABILITIES</h3>
                                <p> We provide expert support around transformation including (but not limited to):
                                </p>
                                <ul>
                                    <li>magna aliqua enim</li>
                                    <li>veniam quis nostrud duis</li>
                                    <li>dolor sit ipusm lorme</li>
                                    <li>exercitation ullamco</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-8" data-aos="fade-right" data-aos-duration={1000}>
                            <div className="service-certificateContent">
                                <h3>duis voluptatern</h3>
                                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Culpa, laborum qui? Eum, quos
                                    earum, aspernatur non ut dolorem perferendis corrupti debitis molestiae exercitationem
                                    explicabo soluta quae vel. Velit dignissimos consequuntur ducimus labore temporibus neque
                                    aliquid quod quam nemo modi quisquam, explicabo magni incidunt. Quaerat itaque, voluptate
                                    eligendi cum incidunt porro.</p>
                                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nulla quae perferendis temporibus
                                    optio aliquam ullam, vero quam itaque impedit molestias! Assumenda ratione vitae quos,
                                    quidem suscipit optio accusamus! Laborum tenetur voluptatibus a cum aperiam corrupti illo
                                    reprehenderit numquam aliquid, illum aspernatur, quis ab sed itaque non autem quam esse?
                                    Doloremque illo nulla impedit, nihil facere esse voluptate necessitatibus nemo labore sequi
                                    perspiciatis amet dolorum commodi eveniet quaerat! Excepturi, molestiae expedita.</p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default ServiceDetail